/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconAndroid({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconAndroid">  <path fill="currentColor" d="M76 162c0 10.2 6.9 19 17.1 19h7.9v25.9c0 5.1 3.1 9.8 7.8 11.6 8.4 3.1 15.2-4.9 15.2-12.9V181h12v24.5c0 6.8 7.1 13.6 12.4 13.6 6.9 0 11.6-6.8 11.6-13.6V181h6.2c10.2 0 19.8-7.9 19.8-18.1V96H76v66zm76.4-123.3l7.8-15c.4-.8.1-1.6-.7-2-.8-.4-1.7-.2-2.1.6l-7.9 15.3c-6.2-2.4-12.8-4.2-19.9-4.2-7.1 0-13.9 1.8-20.2 4.2l-7.9-15.2c-.4-.7-1.2-1-1.9-.6s-1.3 1.3-.9 2l7.8 15c-17.5 7.9-28.8 25.4-31 45.3h109.7c-2.1-20-15.3-37.4-32.8-45.4zm-42.3 32.8c-4.6 0-8.4-3.7-8.4-8.4s3.7-8.4 8.4-8.4 8.4 3.7 8.4 8.4-3.8 8.4-8.4 8.4zm40.6 0c-4.6 0-8.4-3.7-8.4-8.4s3.7-8.4 8.4-8.4 8.4 3.7 8.4 8.4-3.8 8.4-8.4 8.4zM57 158c-6.6 0-12-5.4-12-12V93c0-6.6 5.4-12 12-12s12 5.4 12 12v53c0 6.6-5.4 12-12 12zm148 0c-6.6 0-12-5.4-12-12V93c0-6.6 5.4-12 12-12h.1c6.6 0 12 5.4 12 12v53c-.1 6.6-5.5 12-12.1 12z" /></svg>
  );
}

IconAndroid.propTypes = iconPropTypes;
IconAndroid.defaultProps = iconDefaultProps;
